// Constants
import { ERROR_TYPES } from 'constants/clutchValet';
export const errorLoadingServices = ({ errors: { services } }) => {
  for (const error in services) {
    if (!services[error]) {
      return false;
    }
  }
  return true;
};

export const errorLoadingDayTime = ({ errors: { dayTime } }) => dayTime;

export const errorLoadingApptOption = ({ errors: { apptOption } }) =>
  apptOption;

export const errorLoadingAdvisors = ({ errors: { noAdvisors } }) => noAdvisors;

export const errorLoadingClutchSlots = ({ errors: { externalValetLoaner } }) =>
  externalValetLoaner === ERROR_TYPES.GENERIC_ERROR;

export const errorValidatingPickupAddress = ({
  errors: { externalValetLoaner }
}) => externalValetLoaner === ERROR_TYPES.PICK_UP_OUT_OF_RANGE;

export const errorValidatingDropoffAddress = ({
  errors: { externalValetLoaner }
}) => externalValetLoaner === ERROR_TYPES.DROP_OFF_OUT_OF_RANGE;

export const errorClutchLoanerNotAvailable = ({
  errors: { externalValetLoaner }
}) => externalValetLoaner === ERROR_TYPES.NO_LOANER_AVAILABLE;

export const errorInvalidPickUpAddress = ({
  errors: { externalValetLoaner }
}) => externalValetLoaner === ERROR_TYPES.PICK_UP_INVALID_ADDRESS;

export const errorInvalidDropOffAddress = ({
  errors: { externalValetLoaner }
}) => externalValetLoaner === ERROR_TYPES.DROP_OFF_INVALID_ADDRESS;



// WEBPACK FOOTER //
// ./src/store/reducers/errors/selectors.js